
// const BASE_URL = "https://wowspent-api.hardkore.tech/"; // develop
const BASE_URL = "https://api.wowspent.com/"; // production`
// const BASE_URL = "http://192.168.0.101:8000/"; // local

// const BASE_URL = "https://dev-wowspent-backend.hardkore.tech/"; // Development
const API_URL = BASE_URL + "api/admin/";

const INITIAL_TOKEN = "e6e2b3f3-855f-454d-b947-8b0504933a1b";

export { API_URL, BASE_URL, INITIAL_TOKEN };
